export default [
    {
        name: 'cadastro-sistema',
        path: 'sistema',
        redirect: 'sistema/index',
        component: () => import(/* webpackChunkName: 'cadastro-sistema' */ '@/views/cadastro/sistema/Index'),
        children: [
            {
                meta: {title: 'Lista de sistemas'},
                name: 'cadastro-sistema-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-sistema' */ '@/views/cadastro/sistema/List.vue'),
            },
            {
                meta: {title: 'Cadastro de sistema'},
                name: 'cadastro-sistema-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-sistema' */ '@/views/cadastro/sistema/Form.vue'),
            },
            {
                meta: {title: 'Edição de sistema'},
                name: 'cadastro-sistema-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-sistema' */ '@/views/cadastro/sistema/Form.vue'),
            },
        ],
    },
]